import { render, staticRenderFns } from "./DesktopNotice.vue?vue&type=template&id=b7a4a0de&scoped=true"
import script from "./DesktopNotice.vue?vue&type=script&lang=js"
export * from "./DesktopNotice.vue?vue&type=script&lang=js"
import style0 from "./DesktopNotice.vue?vue&type=style&index=0&id=b7a4a0de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a4a0de",
  null
  
)

export default component.exports